import { useMemo } from 'react';

const MS_PER_MINUTE = 1000 * 60;

const SHORT_EVENT_MAX_MINUTES = 45;
const MEDIUM_EVENT_MAX_MINUTES = 60;

const SHORT_EVENT_LINES = 1;
const MEDIUM_EVENT_LINES = 3;
const LONG_EVENT_LINES = 4;

export const useTimeBasedStyle = (startDate?: string, endDate?: string) =>
  useMemo(() => {
    if (!startDate || !endDate) {
      return { numberOfLines: MEDIUM_EVENT_LINES };
    }

    const minutes =
      (new Date(endDate).getTime() - new Date(startDate).getTime()) /
      MS_PER_MINUTE;

    if (minutes < SHORT_EVENT_MAX_MINUTES) {
      return { numberOfLines: SHORT_EVENT_LINES };
    }

    if (minutes < MEDIUM_EVENT_MAX_MINUTES) {
      return { numberOfLines: MEDIUM_EVENT_LINES };
    }

    return { numberOfLines: LONG_EVENT_LINES };
  }, [endDate, startDate]);
